import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import C from "../../Constants";
import moment from "moment";

// 船舶マスターリポジトリ
const enterpriseManningVesselsRepository = AiseaApiFactory.get(
  "enterpriseManningVessels"
);

/**
 * 船舶マスターサービス
 */
const EnterpriseManningVesselsService = (() => {
  let _enterpriseManningVessels = null;
  let _rolePostionDict = null;

  const fetch = async () => {
    const payload = {
      details: ["MANNING_VESSEL_ROLE_POSITION", "MANNING_VESSEL_ROLE"],
    };
    const res = await enterpriseManningVesselsRepository.fetch(payload);
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseManningVessels = res.data;

    // 役職ポジションの辞書を作成
    _rolePostionDict = _enterpriseManningVessels.manning_vessels.reduce(
      (acc, vessel) => {
        vessel.manning_vessel_roles.forEach(role => {
          role.manning_vessel_role_positions.forEach(position => {
            const key = `${position.id}`;
            acc[key] = position;
          });
        });
        return acc;
      },
      {}
    );

    return _enterpriseManningVessels;
  };
  /**
   * 配乗可能、船舶、役職ポジションの一覧を取得する
   * @param {Date} date - 日付
   * @param {string} crewId - クルーID
   * @returns {Promise<Array>} - 配乗可能な船舶、役職ポジションの一覧
   * @throws {Object} - エラーオブジェクト
   */
  const fetchAssignable = async (date, crewId) => {
    const dateStr = moment(date).format("YYYY-MM-DD");

    const payload = {
      details: ["MANNING_VESSEL_ROLE_POSITION", "MANNING_VESSEL_ROLE"],
      date_at: dateStr,
      enterprise_crew_id: crewId,
    };
    const res = await enterpriseManningVesselsRepository.fetchAssignable(
      payload
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  /**
   *  役職ポジションの辞書を取得する
   * @returns {Object|null} - 役職ポジションの辞書
   */
  const getRolePositionDict = () => {
    if (!_rolePostionDict) {
      return null;
    }
    return _rolePostionDict;
  };

  /**
   *  船舶マニング情報を取得する
   * @returns {Object|null} - 船舶マニング情報
   */
  const getEnterpriseManningVessels = () => {
    if (!_enterpriseManningVessels) {
      return null;
    }
    return _enterpriseManningVessels;
  };

  const clear = () => {
    _enterpriseManningVessels = null;
  };

  const findById = id => {
    if (!_enterpriseManningVessels) {
      return null;
    }

    return (
      _enterpriseManningVessels.manning_vessels.find(
        vessel => vessel.id === id
      ) || null
    );
  };

  /**
   * 役職ポジションを船舶ID、役職ID、役職ポジションIDで検索する
   * @param {string} rolePositionId
   * @returns
   */
  const findRolePositionById = rolePositionId => {
    if (!_rolePostionDict || !_rolePostionDict[rolePositionId]) {
      return null;
    }
    const rolePosition = _rolePostionDict[rolePositionId];
    if (!rolePosition) {
      return null;
    }

    return rolePosition;
  };

  /**
   * 船舶の航行区域名を取得する
   * @param {Object} vessel - 船舶オブジェクト
   */
  const getNavigationAreaName = vessel => {
    if (!vessel || !vessel.navigation_area) {
      return "";
    }
    let navigationAreaName =
      C.VESSEL_NAVIGATION_AREA_NAME[vessel.navigation_area];
    if (!navigationAreaName) {
      // 航行区域名が定義されていない場合は空文字を返す
      navigationAreaName = "";
    }
    return navigationAreaName;
  };

  /**
   * 船舶の航行時間名を取得する
   * @param {Object} vessel - 船舶オブジェクト
   * @returns {string} 航行時間名
   */
  const getNavigationTimeName = vessel => {
    if (!vessel || !vessel.navigation_time) {
      return "";
    }

    let navigationTimeName =
      C.VESSEL_NAVIGATION_TIME_NAME[vessel.navigation_time];
    if (!navigationTimeName) {
      // 航行時間名が定義されていない場合は空文字を返す
      navigationTimeName = "";
    }
    return navigationTimeName;
  };

  return {
    fetch,
    fetchAssignable,
    getEnterpriseManningVessels,
    getRolePositionDict,
    clear,
    findById,
    findRolePositionById,
    getNavigationAreaName,
    getNavigationTimeName,
  };
})();

export default EnterpriseManningVesselsService;
